
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stress-test",
      function () {
        return require("private-next-pages/stress-test.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stress-test"])
      });
    }
  